<script>

    import Menu from './menu.layout.svelte'
    import Container from './container.layout.svelte'

</script>

<style>

    .page-wrapper {
        margin-left: 240px;
        min-height: 100vh;
        background-color: #f4f5f7;
    }

    @media (max-width: 862px) {
        .page-wrapper {
            margin-left: 0;
            padding-top: 56px;
        }
    }

</style>

<Menu />
<div class="page-wrapper">
    <Container>
        <slot></slot>
    </Container>
</div>
